module.exports = __webpack_public_path__ + "img/CompScope_Mag_4_Focus_0.83c4a1e2.png";